import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const SUPERADMIN_EMAIL = 'designdasilva@gmail.com';

export default function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const resolve = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (!session) {
        navigate('/entrar', { replace: true });
        return;
      }

      // Superadmin vai direto para /admin
      if (session.user.email === SUPERADMIN_EMAIL) {
        navigate('/admin', { replace: true });
        return;
      }

      // Busca username do usuário
      const { data: profile } = await supabase
        .from('user_profiles')
        .select('username')
        .eq('user_id', session.user.id)
        .maybeSingle();

      if (profile?.username) {
        const isPreview = window.location.hostname.includes('lovable.app')
          || window.location.hostname === 'localhost';

        if (isPreview) {
          navigate(`/${profile.username}/admin`, { replace: true });
        } else {
          const accessToken = session?.access_token;
          const refreshToken = session?.refresh_token;
          window.location.href = `https://${profile.username}.criaaa.com/admin?access_token=${accessToken}&refresh_token=${refreshToken}`;
        }
      } else {
        navigate('/onboarding', { replace: true });
      }
    };

    const timeout = setTimeout(resolve, 800);
    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div style={{
      background: 'var(--bg)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'IBM Plex Mono', monospace",
    }}>
      <span style={{ fontSize: 'var(--type-body)', color: 'var(--muted)' }}>entrando...</span>
    </div>
  );
}
